// 一元运算符
const EMPTY = (n) => ({ type: 'formula', formula: { op: 'empty', input: [n] } });
const RAND = (n) => ({ type: 'formula', formula: { op: 'random', input: [n] } });
const PASS = (n) => ({ type: 'formula', formula: { op: 'pass', input: [n] } });
const MD5 = (n) => ({ type: 'formula', formula: { op: 'md5', input: [n] } });
const UNHEX = (n) => ({ type: 'formula', formula: { op: 'unhex', input: [n] } });
const NOT = (n) => ({ type: 'formula', formula: { op: 'not', input: [n] } }); // 否
const HEX_TO_INT = (n) => ({ type: 'formula', formula: { op: 'h_to_i', input: [n] } });
const GET_DAY_STAMP = (n) => ({ type: 'formula', formula: { op: 'get_day_stamp', input: [n] } });
const PRC_ID_CARD_BIRTHDAY = (n) => ({
  type: 'formula',
  formula: { op: 'prc_id_card_birthday', input: [n] },
});
const INT_TO_MEMORY = (a) => ({ type: 'formula', formula: { op: 'i_to_m', input: [a] } });
const MIVC = (a) => ({ type: 'formula', formula: { op: 'mivc', input: [a] } });
// 二元运算符
const GET_WEEK_STAMP = (a, b) => ({
  type: 'formula',
  formula: { op: 'get_week_stamp', input: [a, b] },
});
const GET_MONTH_STAMP = (a, b) => ({
  type: 'formula',
  formula: { op: 'get_month_stamp', input: [a, b] },
});
const GET_QUARTER_STAMP = (a, b) => ({
  type: 'formula',
  formula: { op: 'get_quarter_stamp', input: [a, b] },
});
const GET_YEAR_STAMP = (a, b) => ({
  type: 'formula',
  formula: { op: 'get_year_stamp', input: [a, b] },
});
const ADD = (a, b) => ({ type: 'formula', formula: { op: 'add', input: [a, b] } });
const SUB = (a, b) => ({ type: 'formula', formula: { op: 'subtract', input: [a, b] } });
const MUL = (a, b) => ({ type: 'formula', formula: { op: 'multiply', input: [a, b] } });
const DIV = (a, b) => ({ type: 'formula', formula: { op: 'divide', input: [a, b] } });
const MOD = (a, b) => ({ type: 'formula', formula: { op: 'mod', input: [a, b] } });
const EQUAL = (a, b) => ({ type: 'formula', formula: { op: 'equal', input: [a, b] } }); // 等于
const NOT_EQUAL = (a, b) => ({ type: 'formula', formula: { op: 'not_equal', input: [a, b] } }); // 不等于
const PRECISION = (a, b) => ({ type: 'formula', formula: { op: 'precision', input: [a, b] } });
const FIXED = (a, b) => ({ type: 'formula', formula: { op: 'fixed', input: [a, b] } });
const FLOOR = (a, b) => ({ type: 'formula', formula: { op: 'floor', input: [a, b] } });
const CEIL = (a, b) => ({ type: 'formula', formula: { op: 'ceil', input: [a, b] } });
const LESS = (a, b) => ({ type: 'formula', formula: { op: 'less', input: [a, b] } }); // 小于
const LESS_EQUAL = (a, b) => ({ type: 'formula', formula: { op: 'less_equal', input: [a, b] } }); // 小于等于
const GREAT = (a, b) => ({ type: 'formula', formula: { op: 'great', input: [a, b] } }); // 大于
const GREAT_EQUAL = (a, b) => ({ type: 'formula', formula: { op: 'great_equal', input: [a, b] } }); // 大于等于
const INT_TO_STRING = (a, b) => ({ type: 'formula', formula: { op: 'i_to_s', input: [a, b] } });
const INT_TO_BASE64 = (a, b) => ({ type: 'formula', formula: { op: 'i_to_b', input: [a, b] } });
const I_TO_G = (a, b) => ({ type: 'formula', formula: { op: 'i_to_g', input: [a, b] } });
const SHUFFLE_CASE = (a, b) => ({
  type: 'formula',
  formula: { op: 'shuffle_case', input: [a, b] },
});

const DEPARTMENT = (a, b = 0) => ({
  type: 'formula',
  formula: { op: 'department', input: [a, b] },
});

const ADD_YEAR = (a, b) => ({ type: 'formula', formula: { op: 'add_year', input: [a, b] } });

const DATE = (a, b) => ({ type: 'formula', formula: { op: 'date', input: [a, b] } });
const INDEX_OF = (a, b) => ({ type: 'formula', formula: { op: 'index_of', input: [a, b] } });
const DISTANCE = (a, b) => {
  if (typeof a?.prop === 'number') a = a.prop;
  if (typeof b?.prop === 'number') b = b.prop;
  return { type: 'formula', formula: { op: 'distance', input: [a, b] } };
};
const M_DAY = (a, b) => ({ type: 'formula', formula: { op: 'm_day', input: [a, b] } });

const LEFT = (a, b) => ({ type: 'formula', formula: { op: 'left', input: [a, b] } });
const RIGHT = (a, b) => ({ type: 'formula', formula: { op: 'right', input: [a, b] } });

// 三元运算符
const N_DAY = (a, b = 4, c = 16) => ({
  type: 'formula',
  formula: { op: 'n_day', input: [a, b, c] },
});
const IF = (a, b, c) => ({ type: 'formula', formula: { op: 'if', input: [a, b, c] } });
const SLICE = (a, b, c) => ({ type: 'formula', formula: { op: 'slice', input: [a, b, c] } });
const DATE_SEQ = (a, b, c) => ({ type: 'formula', formula: { op: 'date_seq', input: [a, b, c] } });
// 多元运算符
const EXACTLY_SAME = (...input) => ({ type: 'formula', formula: { op: 'exactly_same', input } }); // input[0]和input.slice(1)完全相等
const OR = (...input) => ({ type: 'formula', formula: { op: 'or', input } });
const FVV = (...input) => ({ type: 'formula', formula: { op: 'fvv', input } });
const SUM = (...input) => ({ type: 'formula', formula: { op: 'sum', input } });
const AVG = (...input) => ({ type: 'formula', formula: { op: 'avg', input } });
const MAX = (...input) => ({ type: 'formula', formula: { op: 'max', input } });
const MIN = (...input) => ({ type: 'formula', formula: { op: 'min', input } });
const COUNT = (...input) => ({ type: 'formula', formula: { op: 'count', input } });
const CONCAT = (...input) => ({ type: 'formula', formula: { op: 'concat', input } });
const NICK_NAME = (...input) => ({ type: 'formula', formula: { op: 'nick_name', input } });
const NICK_NAMES = (...input) => ({ type: 'formula', formula: { op: 'nick_names', input } });
const JOIN = (sep, ...input) => ({
  type: 'formula',
  formula: { op: 'join', input: [sep, ...input] },
});
const ADD_PREFIX = (prefix, ...input) => ({
  type: 'formula',
  formula: { op: 'add_prefix', input: [prefix, ...input] },
});
const AND = (...input) => ({ type: 'formula', formula: { op: 'and', input } });
const XOR = (...input) => ({ type: 'formula', formula: { op: 'xor', input } });
const PASS_ARRAY = (...input) => ({ type: 'formula', formula: { op: 'pass_array', input } });
const PASS_ANY = (...input) => ({ type: 'formula', formula: { op: 'pass_any', input } });
const INCLUDE = (data, ...input) => ({
  type: 'formula',
  formula: { op: 'include', input: [data, ...input] },
});
const TEXT_INCLUDE = (data, ...input) => ({
  type: 'formula',
  formula: { op: 'text_include', input: [data, ...input] },
});

// 属性
const PROP = (n) => ({ type: 'prop', prop: n });
const STATUS_PROP = (n) => ({ type: 's_prop', prop: n });
const CAS_PROP = (n, split = '/') => ({ type: 'cas_prop', prop: n?.prop ?? n, split });
const CAS_PROP_N = (n, i) => ({ type: 'cas_prop_n', prop: n?.prop ?? n, level: i });
const CONST = (...n) =>
  n.length === 1 ? { type: 'const', const: n[0] } : { type: 'const', const: n };
const NODE_ID = () => ({ type: 'node_id' });
const NODE_SEQ = () => ({ type: 'node_seq' });
const NOW = () => ({ type: 'now' });
const CREATE_TIME = () => ({ type: 'create_time' });
const QUOTA = (
  temp_id,
  prop,
  remoteProp,
  quotaProp,
  si = null,
  parentId = null,
  filter = undefined,
) => ({
  type: 'quota',
  temp_id,
  prop,
  remoteProp,
  quotaProp,
  si,
  parentId,
  filter,
});
const QUOTE = (
  temp_id,
  prop,
  remoteProp,
  quotaProp,
  si = null,
  parentId = null,
  filter = undefined,
) => ({
  type: 'quote',
  temp_id,
  prop,
  remoteProp,
  quotaProp,
  si,
  parentId,
  filter,
});
const QUOTE_VALUE = (
  temp_id,
  prop,
  remoteProp,
  quotaProp,
  si = null,
  parentId = null,
  filter = undefined,
) => ({
  type: 'quote_value',
  temp_id,
  prop,
  remoteProp,
  quotaProp,
  si,
  parentId,
  filter,
});

const IMM = () => ({ type: 'immediate' });
const CREATOR = () => ({ type: 'creator' });
const STATUS = () => ({ type: 'status' });
const STATUS_NAME = () => ({ type: 'status_name' });
const TAG = () => ({ type: 'tag' });
const TRIGGER = () => ({ type: 'trigger' });
// 组合函数
const RANDOM_ID = (n) =>
  INT_TO_STRING(MUL(NODE_SEQ(), ((10 ** n - 1) / 3) * 2 - (49 % 10 ** n)), n);

module.exports = {
  EMPTY,
  RAND,
  PASS,
  MD5,
  UNHEX,
  NOT,
  HEX_TO_INT,
  ADD,
  SUB,
  MUL,
  DIV,
  MOD,
  EQUAL,
  NOT_EQUAL,
  PRECISION,
  FIXED,
  LESS,
  LESS_EQUAL,
  GREAT,
  GREAT_EQUAL,
  INT_TO_STRING,
  INT_TO_BASE64,
  INT_TO_MEMORY,
  I_TO_G,
  SHUFFLE_CASE,
  DATE,
  IF,
  SLICE,
  OR,
  FVV,
  SUM,
  AVG,
  MAX,
  MIN,
  COUNT,
  CONCAT,
  JOIN,
  AND,
  XOR,
  PROP,
  STATUS_PROP,
  CONST,
  NODE_ID,
  NODE_SEQ,
  NOW,
  CREATE_TIME,
  QUOTA,
  QUOTE,
  QUOTE_VALUE,
  IMM,
  CAS_PROP,
  CAS_PROP_N,
  ADD_PREFIX,
  PASS_ARRAY,
  PASS_ANY,
  NICK_NAME,
  NICK_NAMES,
  INCLUDE,
  TEXT_INCLUDE,
  CREATOR,
  STATUS,
  STATUS_NAME,
  INDEX_OF,
  TAG,
  EXACTLY_SAME,
  N_DAY,
  M_DAY,
  GET_DAY_STAMP,
  DISTANCE,
  RANDOM_ID,
  ADD_YEAR,
  FLOOR,
  CEIL,
  TRIGGER,
  PRC_ID_CARD_BIRTHDAY,
  DEPARTMENT,
  LEFT,
  RIGHT,
  GET_WEEK_STAMP,
  GET_MONTH_STAMP,
  GET_QUARTER_STAMP,
  GET_YEAR_STAMP,
  DATE_SEQ,
  MIVC,
};
